import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { JournalEntry } from 'app/core/model/journal-entry';
import { DxFormModule } from 'devextreme-angular';
import validationEngine from 'devextreme/ui/validation_engine';
import _ from 'lodash';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-journal-entry-dialog',
    standalone: true,
    imports: [DxFormModule],
    templateUrl: './journal-entry-dialog.component.html',
    styleUrl: './journal-entry-dialog.component.scss',
})
export class JournalEntryDialogComponent implements OnInit {
    uow = inject(BrewersUnitOfWork);
    auth = inject(AuthService);
    appInfo = inject(AppInformationService);

    result = new Subject<{ success: boolean; value?: JournalEntry }>();

    journalEntry: JournalEntry;
    quickBooksAccounts: { id: number; quickBooksAccountNumber: string; name: string; displayName: string }[];
    readOnly: boolean = true;

    async ngOnInit() {
        await this.appInfo.pleaseWaitShow();
        await this.getQuickBooksAccounts();
        if (!this.journalEntry) {
            this.journalEntry = this.uow.journalEntries.createEntity({
                amount: null,
                creditAccountId: null,
                debitAccountId: null,
                journalEntryDate: new Date(),
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            });
        }
        this.readOnly = !!this.journalEntry.quickBooksId;
        await this.appInfo.pleaseWaitHide();
    }

    async getQuickBooksAccounts() {
        this.quickBooksAccounts = (await this.uow.getQuickBooksAccounts('id, quickBooksAccountNumber, name')) as any[];
        this.quickBooksAccounts.forEach((dto) => (dto.displayName = `${dto.quickBooksAccountNumber ? `${dto.quickBooksAccountNumber} -` : ''} ${dto.name ?? ''}`));
    }

    async save() {
        const success = this.valid();
        if (!success) return;

        await this.appInfo.pleaseWaitShow();
        await this.uow.commit([this.journalEntry]);
        await this.appInfo.pleaseWaitHide();
        this.result.next({ success: true, value: this.journalEntry });
    }

    cancel() {
        this.journalEntry.entityAspect.rejectChanges();
        this.result.next({ success: false });
    }

    valid() {
        const groupConfig = validationEngine.getGroupConfig('journalEntryValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('journalEntryValidationGroup');
            return result.isValid;
        } else return false;
    }
}
